// AIT-529 — /invite/done, the last screen of the invited-signup flow.
//
// The client connected their channel and is finished: no workspace, no
// dashboard. The one onward step is connecting a second channel, which loops
// back to the picker. PUBLIC on purpose — a protected route here would
// fire the whole authed workspace bootstrap (/workspaces, usage, channels)
// behind a screen that shows nothing but a confirmation.

import { useEffect } from 'react';
import { Link } from 'react-router';
import { Check } from 'lucide-react';
import { clearInviteConnectPending } from '@/lib/invite-connect';
import { PageShell } from './page-shell';

export function InviteDonePage() {
  useEffect(() => {
    clearInviteConnectPending();
  }, []);

  return (
    <PageShell>
      <div className="relative z-10 w-full max-w-md rounded-[20px] border border-white/10 bg-white/[0.04] px-8 py-10 text-center shadow-[0_12px_28px_rgba(0,0,0,0.2),0_2px_4px_rgba(0,0,0,0.1)] backdrop-blur-sm">
        <span className="mx-auto mb-6 flex size-14 items-center justify-center rounded-full bg-[#25D366]/15">
          <Check className="size-7 text-[#25D366]" aria-hidden="true" />
        </span>
        <h1 className="text-2xl font-semibold text-white" role="status">
          You&rsquo;re all set
        </h1>
        <p className="mt-3 text-[15px] leading-relaxed text-white/70">
          Your channel is connected. You can close this tab, or connect another one.
        </p>
        <Link
          to="/invite/connect"
          className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-[100px] bg-[#0064E0] px-8 py-4 text-base font-medium text-white transition hover:bg-[#0143B5] active:bg-[#004BB9]"
        >
          Connect another channel
        </Link>
      </div>
    </PageShell>
  );
}
